import React from 'react'
import { css } from '@emotion/react'
import { Typography } from '../base-ui'
// import PostCardH from './PostCardH'

function RecentPost() {
    const style = css`
        padding: 3rem 3rem 1rem 1rem;
        .title {
            margin-bottom: 2rem;
        }
    `
    return (
        <div css={style}>
            <Typography type="h4" className="title" fontWeight="Semi Bold">
                Recent Post
            </Typography>
            {/* <PostCardH
                src="/img/project/thum1.jpg"
                title="How To Get People To Like Industry"
                uptitle="Completely Responsive"
                date="21/4/1401"
            /> */}
        </div>
    )
}

export default RecentPost
